<script>
    import { getContext } from 'svelte';

    // --- Properties
    export let dataKey;
    const { rejectedMatches, restoreMatch } = getContext(dataKey);
</script>

<div class='row card'>
    <span>Rejected matches:</span>
    {#each $rejectedMatches as match}
        <span class='button' 
              on:click={() => restoreMatch(match)}>
            {match.ccnum}, {match.lynum}
        </span>
    {/each}
</div>

<style>
.button {
    cursor:pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
div {
    flex-wrap: wrap;
}

div span {
    margin-right: 10px;
    font-size:12px;
}
</style>